import axios from "axios";

const SESSION_TOKEN_KEY = "session_token";
const COURSE_API = "/wp-json/api/v1/course";
const DISCUSSION_API = "/wp-json/api/v1/discussion";
const withNonceHeaders = (config = {}) => {
  const token = window.localStorage.getItem(SESSION_TOKEN_KEY);

  if (!token) {
    return config;
  }

  return {
    ...config,
    headers: {
      ...(config.headers ?? {}),
      "X-WP-Nonce": token,
    },
  };
};

export const fetchCourse = async (courseId) => {
  const { data } = await axios.get(
    `${COURSE_API}/${courseId}`,
    withNonceHeaders(),
  );

  return data;
};

export const fetchCourseProgress = async (courseId) => {
  const { data } = await axios.get(
    `${COURSE_API}/${courseId}/progress`,
    withNonceHeaders(),
  );

  return data;
};

export const updateCourseProgress = async (courseId, payload) => {
  const { data } = await axios.put(
    `${COURSE_API}/${courseId}/progress`,
    payload,
    withNonceHeaders(),
  );

  return data;
};

export const fetchCourseReleases = async (courseId) => {
  const { data } = await axios.get(
    `${COURSE_API}/${courseId}/release`,
    withNonceHeaders(),
  );

  return data;
};

export const fetchCourseValidity = async (courseId) => {
  const { data } = await axios.get(
    `${COURSE_API}/${courseId}/validity`,
    withNonceHeaders(),
  );

  return data;
};

export const fetchLessonDiscussion = async (lessonId) => {
  const { data } = await axios.get(
    `${DISCUSSION_API}/${lessonId}`,
    withNonceHeaders(),
  );

  return data;
};

export const submitLessonDiscussion = async (lessonId, payload) => {
  const { data } = await axios.post(
    `${DISCUSSION_API}/${lessonId}`,
    payload,
    withNonceHeaders(),
  );

  return data;
};

export const fetchDiscussionPost = async (lessonId, postId) => {
  const { data } = await axios.get(
    `${DISCUSSION_API}/${lessonId}/post/${postId}`,
    withNonceHeaders(),
  );

  return data;
};

export const fetchDiscussionResponses = async (lessonId, postId) => {
  const { data } = await axios.get(
    `${DISCUSSION_API}/${lessonId}/responses/${postId}`,
    withNonceHeaders(),
  );

  return data;
};

export const fetchAllDiscussionResponses = async (lessonId, postId) => {
  const { data } = await axios.get(
    `${DISCUSSION_API}/${lessonId}/allresponses/${postId}`,
    withNonceHeaders(),
  );

  return data;
};

export const submitDiscussionResponse = async (lessonId, postId, payload) => {
  const { data } = await axios.post(
    `${DISCUSSION_API}/${lessonId}/response/${postId}`,
    payload,
    withNonceHeaders(),
  );

  return data;
};

export const resolveVideoType = (uri = "", type = "") => {
  if (type) {
    return type;
  }

  const normalizedUri = uri.split("?")[0].toLowerCase();

  if (normalizedUri.endsWith(".mp4")) {
    return "video/mp4";
  }

  if (normalizedUri.endsWith(".webm")) {
    return "video/webm";
  }

  if (normalizedUri.endsWith(".ogg")) {
    return "video/ogg";
  }

  return "application/x-mpegURL";
};
